module.exports.en = require("./en.json");
module.exports.es = require("./es.json");
module.exports.de = require("./de.json");
module.exports.fr = require("./fr.json");
module.exports.nl = require("./nl.json");
module.exports.it = require("./it.json");
